import * as types from "../actions/types";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  crediteCardDetails: "",
};

/******************* 
@purpose : Card Details Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function payment(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /

    case types.SET_CREDITE_CARD_DETAIL:
      return Object.assign({}, ini_data, {
        crediteCardDetails: action.data,
      });

    default:
      return ini_data;
  }
}
